<template>
  <vs-popup :title="$t('user.titles')" :active.sync="visible" id="popup-user" @close="closePopup" ref="vspopup-user">
    <Grid
        ref="grid-user-popup"
        :multipleSelect="true"
        :service="userService"
        @changedSelection="changedSelection"
        route_name="users"
        hide_actions="true"
        order_column="name"
        :request-params="filtersGrid">
      </Grid>
      <!--:request-params="applyFiltersGrid"-->
    <div class="flex flex-row justify-end gap-4">
        <b-button
          @click="addUsers"
          variant="primary"
          icon="add">
          {{ $t('adicionar') }}
        </b-button>
    </div>
  </vs-popup>
</template>

<script>
import UserService from '@/services/api/UserService'

import {
BButton
} from 'bootstrap-vue'

export default {
components: {
  BButton
},
props: {
  visible :{
    type: Boolean,
    default: false
  },
  filters :{
    type: String,
    default: null
  }
},
data: () => ({
  userService: null,
  selectedUsers: []
}),
computed: {
  filtersGrid(){
    return this.filters
  }
},
methods: {
  changedSelection(items) {
    this.selectedUsers = items
  },
  itemSelected(user) {
    const userIndex = this.selectedUsers.findIndex((_user) => _user === user.id)

    if (userIndex !== -1) {
      const newArray = this._.cloneDeep(this.selectedUsers)
      newArray.splice(userIndex, 1)
      this.selectedUsers = newArray
    } else {
      this.selectedUsers.push(user.id)
    }
  },
  addUsers() {
    this.$emit('selected', [...this.selectedUsers])
    this.$emit('close', false)
  },
  closePopup(value){
    this.$emit('close', value)
  },
  applyFiltersGrid(){
    if(this.filters){
      this.getGrid().fillCustomFilters(this.filters)
      this.getGrid().fetchGridData(false)
    }
  },
  getGrid(){
    const gripP = this.$refs['grid-user-popup']
    return gripP
  }
},
beforeMount() {
  this.userService = UserService.build(this.$vs)
},
mounted() {

},
watch: {
  visible(val){
    if(val){
      //this.applyFiltersGrid()
    }
  }
},
}
</script>


<style lang="scss" scoped>
::v-deep .vs-popup {
  width: 800px !important;
}
</style>
